import {formatPrice} from '../../../utils/common'

export const parseCustomerGroupReportRow = (row: any) => ({
  id: row.id,
  customerGroupName: row.customer_group_name || '-',
  customerGroupId: row.customer_group_id || '-',
  orderCount: row.total_order_count || 0,
  discountValue: formatPrice(row.total_discount, false) || 0,
  contributedDiscountPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseCustomerTypeReportRow = (row: any) => ({
  id: row.id,
  customerType: row.customer_type || '-',
  orderCount: row.total_order_count || 0,
  discountValue: formatPrice(row.total_discount, false) || 0,
  contributedDiscountPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseSalesRepReportRow = (row: any) => ({
  id: row.id,
  salesRep: row.rep_name || '-',
  salesRepEmail: row.rep_email || '-',
  salesRepType: row.rep_type || '-',
  orderCount: row.total_order_count || 0,
  discountValue: formatPrice(row.total_discount, false) || 0,
  contributedDiscountPercentage: `${row.contributed_discount_percentage}%` || '0%',
})

export const parseSalesRepTypeReportRow = (row: any) => ({
  id: row.id,
  salesRepType: row.sales_rep_type || '-',
  orderCount: row.total_order_count || 0,
  discountValue: formatPrice(row.total_discount, false) || 0,
  contributedDiscountPercentage: `${row.contributed_discount_percentage}%` || '0%',
})
